module.exports = __webpack_public_path__ + "img/blibli.f64a30d.png";